export default {
  methods: {
    /**
     * Got current live lot
     */
    goToLiveLot: function (inventoryId, delay = true) {
      // establish a random wait time so that we don't hit the frontends at the exact same time
      // when advancing a lot during a live sale
      let minWait = Math.ceil(330)
      let maxWait = Math.floor(1330)
      let randomWait = Math.floor(Math.random() * (maxWait - minWait)) + 330

      // wait 100ms and add the long delay class and remove the short delay
      setTimeout(function () {
        overlayFader.classList.add('longDelay')
        overlayFader.classList.remove('shortDelay')
      }, 100 + randomWait)

      // there is an overlay fader element that allows us to fade out from an item before
      // redirecting them to the next lot (which will fade in)
      let overlayFader = document.getElementById('overlayFader')

      // wait 2000ms and remove the transparent class, causing it to fade to opaque
      setTimeout(function () {
        overlayFader.classList.remove('transparent')
      }, 2000 + randomWait)

      // wait 3000ms and send them to the next lot
      const timeout = delay ? 2330 + randomWait : 30
      setTimeout(function () {
        // If inventoryId is null, live mode is over, go to the home page
        if (!inventoryId || isNaN(inventoryId) || inventoryId < 1) {
          // Go to the home page
          window.location.href = '/'
          return
        }
        window.location.href =
          '/items/' +
          inventoryId +
          '/' +
          '?advanceWithPodium=true&inventoryId=' +
          inventoryId
      }, timeout)
    }
  }
}
